export default Object.freeze([]);